import { render, staticRenderFns } from "./StockAdjustment.vue?vue&type=template&id=a22de3e8&scoped=true&"
import script from "./StockAdjustment.vue?vue&type=script&lang=js&"
export * from "./StockAdjustment.vue?vue&type=script&lang=js&"
import style0 from "./StockAdjustment.vue?vue&type=style&index=0&id=a22de3e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a22de3e8",
  null
  
)

export default component.exports